import { ENV } from "../utils";

export class DataIntegrity {
  baseApi = ENV.BASE_API;

  /**
   * Obtener grupos de períodos duplicados (mismo sitio+año+período) en todos los módulos.
   * @param {string} accessToken
   * @param {string} [siteId] - opcional, filtra a un único sitio
   * @param {string} [companyId] - opcional, acota a los sitios de una empresa (para master)
   */
  async getDuplicatePeriods(accessToken, siteId, companyId) {
    try {
      const queryParams = new URLSearchParams();
      if (siteId) queryParams.append("site", siteId);
      if (companyId) queryParams.append("company", companyId);
      const query = queryParams.toString();

      const url = query
        ? `${this.baseApi}/data-integrity/duplicate-periods?${query}`
        : `${this.baseApi}/data-integrity/duplicate-periods`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Borrar duplicados fusionando antes los campos vacíos del documento que se
   * conserva con los de los que se van a borrar.
   * @param {string} accessToken
   * @param {Array<{module: string, keepId: string, deleteIds: string[], fieldResolutions?: Object}>} groups
   */
  async deleteDuplicatePeriods(accessToken, groups) {
    try {
      const url = `${this.baseApi}/data-integrity/duplicate-periods/delete`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ groups }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
